import type { TDatadogErrorLog } from 'utils/datadog/types'

export const possibleTypes = {
  IContentRecommendation: ['TopicContentRecommendation', 'SubtopicContentRecommendation'],
  IContentRecommendationWeekdays: ['TopicContentRecommendationWeekdays', 'SubtopicContentRecommendationWeekdays'],
  IContentRecommendationWeekdaysRank: [
    'TopicContentRecommendationWeekdaysRank',
    'SubtopicContentRecommendationWeekdaysRank',
  ],
  IContentRecommendationRank: ['TopicContentRecommendationRank', 'SubtopicContentRecommendationRank'],
  IContentRecommendationDuration: ['TopicContentRecommendationDuration', 'SubtopicContentRecommendationDuration'],
  CompanyUnion: ['Company', 'CompanyBasic'],
  WorkspaceUnion: ['Workspace'],
  EntitySearchResult: ['Post', 'Creator'],
  SocialAccountMetricsUnion: ['YTSocialAccountMetrics'],
  LoginUnion: ['LoginSuccess', 'LoginException'],
  LoginResult: ['LoginApproval', 'LoginApprovalException', 'LoginFull'],
  UserUnion: ['User', 'StatusMessage'],
  FetchCreatorResponse: ['Creator', 'StatusMessage', 'FetchInfo'],
  TaggerProjectStatus: ['TaggerProject', 'TaggerProjectMsg'],
  ReportBuilderUnion: ['ReportBuilderReport', 'StatusMessage'],
  ReportBuilderSlideUnion: ['ReportBuilderSlide', 'StatusMessage'],
  ReportBuilderComponentUnion: ['ReportBuilderComponent', 'StatusMessage'],
  ReportBuilderImageUnion: ['ReportBuilderImage', 'StatusMessage'],
  TerritoryInterface: [
    'BrandGroup',
    'BrandTerritory',
    'Event',
    'GlobalTopic',
    'HotTopic',
    'IndustryTopic',
    'Niche',
    'SavedPostSearch',
    'Subtopic',
    'TerritoryTag',
    'Topic',
    'Trending',
    'TrendingSubject',
  ],
}

// Errors that are part of a normal flow and not worth reporting.
export const IGNORED_GRAPHQL_ERROR_MESSAGES = new Set(['PersistedQueryNotFound', 'invalid-password'])

export const FALLBACK_ERROR_LOG: TDatadogErrorLog = {
  from: 'src/lib/apollo-client/link.ts',
  name: 'GraphQL Request Error',
  message: 'A GraphQL operation failed',
}
